import { useQuery } from '@tanstack/react-query';
import type { ElasticFAQItemsResponse } from '@//app/api/faq';
import { useApiBaseUrl, useMarket } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../../httpClient';

export const FAQ_CACHE_KEY = 'api/:market/faq-main';

const useFaq = (params?: URLSearchParams) => {
  const market = useMarket();
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<ElasticFAQItemsResponse>({
    queryKey: [FAQ_CACHE_KEY, market, params?.toString()],
    queryFn: async () => {
      const url = new URL(`${apiBaseUrl}/api/faq`);
      url.search = params?.toString() || '';
      return await httpClientGetJson<ElasticFAQItemsResponse>(url.toString());
    },
  });

  return query;
};

export default useFaq;
